import { render, staticRenderFns } from "./viewsPerMonth.vue?vue&type=template&id=01d28205&"
import script from "./viewsPerMonth.vue?vue&type=script&lang=js&"
export * from "./viewsPerMonth.vue?vue&type=script&lang=js&"
import style0 from "./viewsPerMonth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports